import Swiper, {Autoplay} from 'swiper';

Swiper.use([Autoplay]);

export default class Cases {
    constructor() {
        if (document.getElementById('cases') !== null) {
            this.initCases();
        }
    }

    initCases() {
        const container = document.querySelector('#cases .swiper-container')

        const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: true
            },
            // freeMode: true,
            speed: 7000,
            freeModeMomentum: false,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 3,
                }
            }
        });

        container.addEventListener('mouseenter', function (e) {
            swiper.autoplay.stop();
        });

        container.addEventListener('mouseleave', function (e) {
            swiper.autoplay.start();
        });

        // const interval = setInterval(triggerAutoplay, 200)
        //
        // function triggerAutoplay() {
        //     if (document.querySelector('#cases .swiper-container .project').classList.contains('load')) {
        //         swiper.params.autoplay.delay = 1;
        //         swiper.params.autoplay.disableOnInteraction = false;
        //         swiper.params.speed = 10000;
        //         swiper.autoplay.start();
        //
        //         clearInterval(interval);
        //     }
        // }
    }
}
